import { Component } from "@angular/core";
import { AppRoutes } from "../constants";

@Component({
  selector: "app-tabs",
  templateUrl: "tabs.page.html",
  styleUrls: ["tabs.page.scss"],
})
export class TabsPage {
  public appImagePath: string;
  public routes: typeof AppRoutes = AppRoutes;

  constructor() {
    this.appImagePath = "assets/tabs/app.png";
  }
}
